import {AnswerValue} from '@target-web/leadads-form-view';

export enum EventEnum {
    // общие события
    app_resources_loaded = 'app_resources_loaded',
    resource_loaded = 'resource_loaded',
    resource_loading_error = 'resource_loading_error',
    app_ready = 'app_ready',
    OpenPage = 'open_page',
    ClickToExternalLink = 'click_to_external_link',
    closeCaptcha = 'close_captcha',

    // лидформы
    OpenForm = 'open_form',
    HideForm = 'hide_form',
    RestoreForm = 'restore_form',
    CloseForm = 'close_form',
    get_leadform_data = 'get_leadform_data',
    ClickToCall = 'click_to_call',
    lead_answer = 'lead_answer',
    contact_info_fill = 'contact_info_fill',
    PhoneBanned = 'phone_banned',

    // опросы
    OpenSurvey = 'open_survey',
    HideSurvey = 'hide_survey',
    RestoreSurvey = 'restore_survey',
    CloseSurvey = 'close_survey',
    get_survey_form_data = 'get_survey_form_data',
    respondent_answer = 'respondent_answer',
}

export type EventDataPage = {
    page: string;
};

export type LeadBlockQuestion = {
    block_id: string;
} & AnswerValue;

export type StatEvent = {
    event: EventEnum;
    data?: EventDataPage | LeadBlockQuestion;
};
